// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__tMAvt","Btn":"Pagination_Btn__25vxp","LeftBtn":"Pagination_LeftBtn__GXj0H","RightBtn":"Pagination_RightBtn__z94__"};